const getUIDPart = () => {
  return `${Math.round(Math.random() * 99999)}`.padStart(5, '0');
};

export const genUID = (): string => {
  return `${getUIDPart()}-${getUIDPart()}-${getUIDPart()}`;
};

export const searchIn = (url: string, obj: string): any => {
  if (!obj) {
    return null;
  }
  if (!url) {
    return obj;
  }

  let urlSplit = url.split('/');
  let composed = '';
  let listToSearch = '';
  let rest = '';
  let foundList = false;

  for (let i = 0; i < urlSplit.length; i++) {
    if (foundList) {
      rest += rest ? `/${urlSplit[i]}` : urlSplit[i];
    } else {
      if (urlSplit[i].indexOf(':') > -1) {
        foundList = true;
        listToSearch = urlSplit[i];
      } else {
        composed += composed ? `/${urlSplit[i]}` : urlSplit[i];
      }
    }
  }

  if (!listToSearch) {
    return atUrlInObject(composed, obj);
  }

  let propVal = listToSearch.split(':');

  let root = obj;
  if (composed) {
    root = atUrlInObject(composed, obj);
  }

  let listItem = getObjContainingNestedProp(propVal[0], propVal[1], root);

  return searchIn(rest, listItem);
};

const atUrlInObject = (url, obj) => {
  if (!obj) {
    return null;
  }

  let urlSplit = url.split('/');

  if (urlSplit.length > 0) {
    if (!obj[urlSplit[0]])
      return null;

    if (urlSplit.length == 1)
      return obj[urlSplit[0]];

    let firstElement = urlSplit.shift();

    return atUrlInObject(urlSplit.join('/'), obj[firstElement]);
  }

  return null;
};

const getObjContainingNestedProp = (key, value, list) => {
  if (!list) {
    return null;
  }

  if (key.indexOf('\\') > -1) {
    for (let k in list) {
      if (list[k] && typeof list[k] == 'object') {
        let child = list[k];

        if (containsNestedProp(key, value, child)) {
          return child;
        }
      }
    }

    return null;
  } else {
    return getObjContainingPropInObj(key, value, list);
  }
};

const getObjContainingPropInObj = (key, value, obj) => {
  if (!obj)
    return null;

  for (let k in obj) {
    if (k == key && obj[k] == value || obj[k] && obj[k][key] && obj[k][key] == value) {
      return obj[k];
    }
  }

  return null;
};

const containsNestedProp = (key, value, obj) => {
  if (!obj)
    return false;

  let keySplit = key.split('\\');

  if (keySplit.length > 1) {
    let composed = '';
    let firstKey = keySplit.shift();

    for (let i = 0; i < keySplit.length; i++) {
      composed += keySplit[i];

      if (keySplit.length - 1 > i)
        composed += '\\';
    }

    return containsNestedProp(composed, value, obj[firstKey]);
  } else if (obj[keySplit[0]] && obj[keySplit[0]] == value) {
    return true;
  }
  return false;
};

export const templateString = (str: string, obj: any = {}): string => {
  for (let k in obj) {
    let rgx = new RegExp(`\{\{${k}\}\}`, 'g');
    str = str.replace(rgx, obj[k])
  }
  return str;
};

export const filterObject = (obj: any = {}, predicate: Function): any =>
  Object.keys(obj)
    .filter((key: string) => predicate(obj[key]))
    .reduce((res, key) => (res[key] = obj[key], res), {});
